import { Pipe } from '@angular/core';
import { rightPad, isString } from '../utils/utils';
var RightPadPipe = (function () {
    function RightPadPipe() {
    }
    RightPadPipe.prototype.transform = function (input, length, character) {
        if (length === void 0) { length = 0; }
        if (character === void 0) { character = ' '; }
        if (!isString(input)) {
            return input;
        }
        return rightPad(input, length, character);
    };
    return RightPadPipe;
}());
export { RightPadPipe };
RightPadPipe.decorators = [
    { type: Pipe, args: [{
                name: 'rightpad'
            },] },
];
/** @nocollapse */
RightPadPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=right-pad.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/right-pad.pipe.js
// module id = 287
// module chunks = 103